/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap as cssMapCompiled, jsx } from '@compiled/react';

import CreateTeamOnBoardingSVG from '../icons/CreateTeamOnBoardingSVG';

const DEFAULT_WIDTH = 237;
const DEFAULT_HEIGHT = 271;
const WIDE_WIDTH = 300;
const WIDE_HEIGHT = 343;

const compiledStyles = cssMapCompiled({
	svgWrapperBase: {
		height: 'auto',
	},
});

export default function CreateTeamIcon({ wide }: { wide?: boolean }): React.JSX.Element {
	const width = wide ? WIDE_WIDTH : DEFAULT_WIDTH;
	const height = wide ? WIDE_HEIGHT : DEFAULT_HEIGHT;

	return (
		<div
			css={compiledStyles.svgWrapperBase}
			style={{ width: `${width}px` }}
			data-testid="create-team-internal-default-image-content"
			aria-hidden
		>
			<CreateTeamOnBoardingSVG width={width} height={height} />
		</div>
	);
}
